<template>
    <div class="jumbotron-hero h-80 d-flex align-items-end">
        <div class="row mh-100 align-items-end" style="display:table;">
            <div class="jumbotron-overlay offset-1 offset-sm-1 offset-md-2 offset-lg-2 offset-xl-2 col-10 col-sm-10 col-md-8 col-lg-7 col-xl-6 text-center ps-2 pe-2 ps-sm-2 pe-sm-2 mb-5 pb-5 ps-md-3 pe-md-3 ps-lg-4 pe-lg-5 ps-xl-2 pe-xl-2 mb-lg-5 d-block landscape-margin">
                <div class="row mb-3 d-block">
                    <div class="col-12 offset-0 col-sm-12 offset-sm-0 col-md-12 offset-md-0 col-lg-10 offset-lg-1 col-xl-10 offset-xl-1 pe-md-0 ps-md-0 pe-xl-0 ps-xl-0 mx-auto">
                        <h1 id="hero-headline" class="mx-auto mb-0">The best thing about <span>home</span> is who you share it&nbsp;with.</h1>
                    </div>
                </div>
                <div class="row d-none d-md-block ps-3 pe-3">
                    <div class="col-12 offset-0 mx-auto">
                        <p style="color: rgb(255, 255, 255); font-weight: 500; font-size: 24px; line-height: 1.2;">
                            Our goal is to ensure that our customers' dreams of homeownership become reality.
                            From your first home to your last, we're here to make the loan process smooth and&nbsp;enjoyable.
                        </p>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-12">
                        <button class="btn btn-primary pmbtn d-none d-xl-block" style="margin:0px auto" @click="doStartYourLoan">Start Your Loan Process</button>
                        <button class="btn btn-primary pmbtn d-none d-lg-block d-xl-none" style="margin:0px  auto" @click="doStartYourLoan">Start Your Loan Process</button>
                        <button class="btn btn-primary pmbtn d-none d-md-block d-lg-none" style="margin:0px  auto" @click="doStartYourLoan">Start Your Loan Process</button>
                        <button class="btn btn-primary pmbtn d-md-none d-lg-none d-xl-none" style="margin:0px  auto" @click="doStartYourLoan">Start Your Loan Process</button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import utilitiesMixin from '../../../mixins/Utilities';

    export default {
        name: 'hero',
        analyticsCategory: 'Hero',
        mixins: [utilitiesMixin]        
    };
</script>

<style lang="scss">
    .home {
        .jumbotron-hero

    {
        height: 775px;
        max-height: 970px;
        background-color: rgba(65,74,78,.5);
        #hero-headline

    {
        max-width: 570px;
        margin: 0 auto;
    }

    .jumbotron-overlay {
        padding: 1em 80px 1em 1em;
        text-shadow: 0px 0px 10px #202a2f;
    }

    }

    @media (max-width: 1400px) {
        .jumbotron-hero {
            height: 660px;
            max-height: 970px;
            #hero-headline

    {
        max-width: 585px;
        margin: 0 auto;
    }

    .jumbotron-overlay {
        padding: 1em;
    }

    }
    }

    @media (max-width: 1025px) {
        .jumbotron-hero {
            height: 690px;
            max-height: 970px;
            .jumbotron-overlay

    {
        padding-bottom: 75px;
    }

    #hero-headline {
        max-width: 585px;
        margin: 0 auto;
    }

    }
    }


    @media (max-width: 992px) {
        .jumbotron-hero {
            height: 590px;
            max-height: 970px;
            .jumbotron-overlay

    {
        padding-bottom: 50px;
    }

    #hero-headline {
        max-width: 440px;
        margin: 0 auto;
    }

    }
    }

    @media (max-width: 767px) {


        .jumbotron-hero {
            height: 490px;
            max-height: 970px;
            .jumbotron-overlay

    {
        padding-bottom: 50px;
    }

    #hero-headline {
        max-width: 585px;
        margin: 0 auto;
    }

    }
    }

    @media (max-width:420px) {
        .jumbotron-hero {
            height: 650px;
            max-height: 970px;
            .jumbotron-overlay

    {
        padding-bottom: 40px;
    }

    #hero-headline {
        max-width: 420px;
        margin: 0 auto;
    }

    }
    }

    @media (max-width: 375px) {


        .jumbotron-hero {
            height: 500px;
            max-height: 970px;
            .jumbotron-overlay

    {
        padding-bottom: 30px;
        h1

    {
        font-size: 26px;
    }

    }
    }
    }

    @media (max-height:420px) and (max-width:767px) {
        .jumbotron-hero {
            min-height: 340px;
            height: 340px;
            max-height: 970px;
            .jumbotron-overlay

    {
        padding-bottom: 50px;
    }

    }
    }

 @media screen and (min-width:615px) and (max-width:1024px) and (orientation:landscape){
.landscape-margin{
    margin-bottom: 0rem !important;
}
}
}

</style>